
export const handleFormatTypesString = (type: string) => {
  switch (type) {
    case 'campaignUpdates':
      return 'Campaign Updates'
    case 'updates':
    case 'Updates':
      return 'Updates'
    case 'conversionTracking':
      return 'Conversion Tracking'
    case 'reviewAudit':
    case 'Review / Audit':
      return 'Review / Audit'
    case 'budget':
    case 'Budget':
      return 'Budget'
    case 'createSetup':
    case 'Create / Setup':
      return 'Create / Setup'
    case 'newClientOnboard':
    case 'New Client Onboard':
      return 'New Client Onboard'
    case 'campaignChecklists':
    case 'Campaign Checklists':
      return 'Campaign Checklists'
    case 'adApprovals':
    case 'Ad Approvals':
      return 'Ad Approvals'
    case 'pause':
    case 'Pause':
      return 'Pause'
    case 'enable':
    case 'Enable':
      return 'Enable'
    case 'Social Ads':
    case 'socialAd':
    case 'socialAds':
      return 'Social Ads'
    case 'displayAds':
    case 'Display Ads':
      return 'Display Ads'
    case 'organicSocial':
    case 'Organic Social':
      return 'Organic Social'
    case 'photography':
    case 'Photography':
      return 'Photography'
    case 'printDesign':
    case 'Print Design':
      return 'Print Design'
    case 'website':
    case 'Website':
      return 'Website'
    case 'websiteStructure':
    case 'Website Structure':
      return 'Website Structure'
    case 'video':
    case 'Video':
      return 'Video'
    case 'logoDesign':
    case 'Logo Design':
      return 'Logo Design'
    case 'fullBrandBuild':
    case 'Full Brand Build':
      return 'Full Brand Build'
    case 'websiteDesignOverview':
    case 'Website Design Overview':
      return 'Website Design Overview'
    case 'Misc Creative':
    case 'miscCreative':
      return 'Misc Creative'
    case 'Hosting':
    case 'hosting':
      return 'Hosting'
    case 'Design':
    case 'design':
      return 'Misc Design'
    case 'monthly':
    case 'Monthly':
      return 'Monthly'
    default:
      return ''
  }
}

export const FIELD_ORDER: Record<string, string[]> = {
  search: [
    'searchPlatform',
    'searchBudget',
    'searchUpdate',
    'searchReview',
    'searchCreate',
    'searchNco',
    'searchCampaignPlatform',
    'searchAdPlatform',
    'searchAdApprovals',
    'searchPause',
    'searchEnable',
  ],
  social: [
    'socialPlatform',
    'socialBudget',
    'socialUpdate',
    'socialReview',
    'socialCreate',
    'socialNco',
    'socialCampaignPlatform',
    'socialAdPlatform',
    'socialAdApprovals',
    'socialPause',
    'socialEnable',
  ],
  socialAds: [
    'socialPlatform',
    'socialBudget',
    'socialUpdate',
    'socialReview',
    'socialCreate',
    'socialNco',
    'socialCampaignPlatform',
    'socialAdPlatform',
    'socialAdApprovals',
    'socialPause',
    'socialEnable',
  ],
  display: [
    'displayPlatform',
    'displayBudget',
    'displayUpdate',
    'displayReview',
    'displayCreate',
    'displayNco',
    'displayCampaignPlatform',
    'displayAdPlatform',
    'displayAdApprovals',
    'displayPause',
    'displayEnable',
  ],
  video: [
    'videoPlatform',
    'videoBudget',
    'videoUpdate',
    'videoReview',
    'videoCreate',
    'videoNco',
    'videoCampaignPlatform',
    'videoAdPlatform',
    'videoAdApprovals',
    'videoPause',
    'videoEnable',
  ],
  integration: [
    'integrationOptions',
    'integrationBudget',
    'integrationUpdate',
    'integrationReview',
    'integrationCreate',
    'integrationNco',
    'integrationCampaignChecklist',
    'integrationAdApprovals',
    'integrationPause',
    'integrationEnable',
  ],
  seo: [
    'seoSpecifics',
    'seoBudget',
    'seoUpdate',
    'seoReview',
    'seoCreate',
    'seoNco',
    'seoCampaignChecklist',
    'seoAdApprovals',
    'seoPause',
    'seoEnable',
  ],
}

export const requestTypeOptions = [
  {
    value: 'Issue',
    label: 'Issue',
    color: 'rgb(238, 40, 99)',
  },
  {
    value: 'Observation',
    label: 'Observation',
    color: 'rgb(168, 202, 255)',
  },
  {
    value: 'Request',
    label: 'Request',
    color: 'rgba(255, 148, 112, 1)',
  },
  {
    value: 'Other',
    label: 'Other',
    color: 'rgb(169, 190, 232)',
  },
]
export const requestedByOptions = [
  {
    key: 'option-internal-1',
    value: 'Internal',
    label: 'Internal',
    color: 'rgb(51, 158, 205)',
  },
  {
    key: 'option-external-2',
    value: 'External',
    label: 'External',
    color: 'rgb(255, 189, 189)',
  },
]
export interface CreativeFormData {
  name: string
  orgId: string
  website: string
  assigner: User
  assignees: User[]
  AM: User[]
  DMS: User[]
  creativeLead: User[]
  priority: string
  startDate: string | null // Allow null values
  endDate: string | null // Allow null values
  deadline: string
  existingClient: boolean
  types: Array<
    | 'socialAds'
    | 'displayAds'
    | 'organicSocial'
    | 'photography'
    | 'printDesign'
    | 'website'
    // | 'websiteDesignOverview'
    // | 'websiteStructure'
    | 'video'
    | 'fullBrandBuild'
    | 'logoDesign'
  >
  requestType: string
  requestedBy: string
  taskType: string | ''
  type: string | ''
  creativeType: string | ''
  createdTime: string
  addtlNotes: string
  creativeStatus: string
  channel: string
  creativeTasksFolderId: string
  tasksFolderId: string
  selectedSubtaskKeys?: string[]
}
export interface MarketingFormData {
  name: string
  orgId: string
  website: string
  assigner: User
  assignees: User[]
  AM: User[]
  DMS: User[]
  priority: string
  startDate: string | null // Allow null values
  endDate: string | null // Allow null values
  deadline: string
  existingClient: boolean
  createdTime: string
  taskType: string | ''
  type: string | ''
  addtlNotes: string
  requestType: string
  requestedBy: string
  typeDesignation: string
  typeDesignationSpecifics: string
  channel: string[]
  channels: string[]
  creativeTasksFolderId: string
  googleDriveFolderId: string
  tasksFolderId: string
  searchPlatform: string
  socialPlatform: string
  displayPlatform: string
  subtaskOptions?: Record<string, any> // You can make this more specific if you have a defined structure
  selectedSubtaskKeys?: string[]
}
// Canonical User type imported from types/users.ts
import { User } from 'types'
export type { User } from 'types'
export interface SocialAdFields {
  dmsAssignment: string
  social_accessToCreative: string
  socialAdTypes: string[] // ✅ Array to store multiple selections
  sameOrNewTemplate: string
  prevRequestLink: string
  reasonForRequestChange: string
  promotingDetails: string
  clientToExclude: string
  callToAction: string
  vibe: string
}

export interface DisplayAdsFields {
  dmsAssignment: string
  display_accessToCreative: string
  displayAdTypes: string[] // ✅ Array to store multiple selections
  sameOrNewTemplate: string
  prevRequestLink: string
  reasonForRequestChange: string
  promotingDetails: string
  clientToExclude: string
  callToAction: string
  vibe: string
}
export interface OrganicSocialFields {
  promotingDetails: string
  callToAction: string
  vibe: string
}
export interface PhotographyFields {
  photographyType: string // Lifestyle, Commercial, Drone, Headshots, Other
  locations_photography: string
  photoUsage: string // Print, Web, Both
}
export interface PrintDesignFields {
  printProjectType: string // Brochure/Booklet, Billboard Ad, Banner/Sign, Vinyl Wrap, Merchandise, Other, Magazine Ad, Sell Sheet/Flyer, Stationary, Fence Screens
  print_dimensions: string
  print_pages: string
  print_creative_asset_link: string
  stockImages: string // Yes, No, Designers Choice
  print_phone: string
  print_address: string
  print_website: string
}
export interface WebsiteFields {
  websiteType: string // Full Website Build, Landing Page, Shopify, Other
  website_existing_domain: string // FieldLabel: Existing Website Domain
  website_new_domain_input: string
  google_analytics_access: string
  website_new_domain: string // FieldLabel: New Website Domain, Options: Have Access, Need Access, Need To Purchase, Not Sure - defer to dev
  website_domain_access: string //FieldLabel: Domain Access, options:  // Have Access, Need Access, Need To Purchase
  // website_ssl_cert: string // FieldLabel: SSL Certificate, Options: // Yes, No, Designers Choice
  website_google_analytics: string //FieldLabel: Google Analytics, Options: // Have Access, Need Access, Need To Create
  website_content: string // FieldLabel: Content, Options: // Migrate Content, Create New Content, Migrate & Create
  website_street: string
  website_phone: string
  website_city: string
  website_state: string
  website_bus_email: string
}
export interface WebsiteDesignFields {
  /// Website Design Overview ///
  website_brand_style: string // FieldLabel: Modern or Traditional, Options: // Modern, Traditional, Other
  website_creative_asset_link: string
  use_stock_images: string //FieldLabel: Use Stock Images?, Options // Yes, No, Defer to creative team
  google_map_site: string // FieldLabel: Need Google Map (On Site), Options // Yes, No, Defer to creative team
  need_contact_form: string // FieldLabel: Need Contract Form?, Options // Yes, No, Defer to creative team
  badge_compliance_images: string // FieldLabel: Badges / Compliance Images Needed
  inspiration_links: string // Multiline, helpertext: Ask the client for websites that they like, and paste the links here for inspiration.
  hero_image_headline: string //FieldLabel: Hero Image Headline
  hero_image_cta: string //FieldLabel: Hero Image CTA
}
export interface WebsiteStructureFields {
  website_pages: number
  main_nav_links: string // FieldLabel: Main Navigation Links, Helpertext: Common Links: Home | About | Floorplans | Gallery | Tour | Location | Contact | Apply
  main_nav_cta: string // FieldLabel Main Navigation CTA, Helpertext: Typically, this is "Contact Us" or "Apply Now"
  footer_nav_links: string
  website_addtl_info: string
}
export interface VideoFields {
  videoType: string // FieldLabel: Type of Video, Options: Lifestyle, Interview, Advertisement, Hype Video Ad, Drone
  goal_of_video: string
  video_target_audience: string
  video_projected_hours: number
  video_locations: string
  video_personell: string //FieldLabel: Who is in the video? (Personell)
  req_text_logo: string //FieldLabel: Please list or link any required text or logos that need to be included
  specific_shots: string // FieldLabel: Did the client request any specific shots? If so, specify below:
  output_channels: string // FieldLabel: Output Channels FieldType: Checkbox, Options: Social Ads, Website, Streaming / TV, Youtube / Display, Other
  video_sizes: string // FieldLabel: Video Sizes FieldType: Checkbox, Options: 16:9 (1920 x 1080 or 4k 3840 x 2160), 1:1, 9:16 (Vertical for Snapchat or Story ads)
  video_min_duration: string
  video_max_duration: string
}
export interface BrandDesignFields {
  brand_deliverables: string // FieldLabel: Contract Deliverables FieldType: Checkbox, Options: Logo, Visual ID, Brand Guide
  brand_target_audience: string
  brand_use_colors: string // FieldLabel:  Colors to Use
  brand_avoid_colors: string // FieldLabel:  Colors to Avoid
  brand_style: string // FieldLabel: Modern or Traditional, Options: // Modern, Traditional, Other
  brand_logo_inspiration: string
  brand_color_picker1: string //FieldLabel Color 1, FieldType: color picker component?
  brand_color_picker2: string //FieldLabel Color 2, FieldType: color picker component?
  brand_color_picker3: string //FieldLabel Color 3, FieldType: color picker component?
}
export interface LogoDesignFields {
  logo_deliverables: string // FieldLabel: Contract Deliverables FieldType: Checkbox, Options: Logo, Visual ID, Brand Guide
  logo_target_audience: string
  logo_use_colors: string // FieldLabel:  Colors to Use
  logo_avoid_colors: string // FieldLabel:  Colors to Avoid
  logo_brand_style: string // FieldLabel: Modern or Traditional, Options: // Modern, Traditional, Other
  logo_inspiration: string
  logo_color_picker1: string //FieldLabel Color 1, FieldType: color picker component?
  logo_color_picker2: string //FieldLabel Color 2, FieldType: color picker component?
  logo_color_picker3: string //FieldLabel Color 3, FieldType: color picker component?
}
export interface CreativeTypeOptions {
  socialAds: SocialAdFields
  displayAds: DisplayAdsFields
  organicSocial: OrganicSocialFields
  photography: PhotographyFields
  printDesign: PrintDesignFields
  website: WebsiteFields & Partial<WebsiteDesignFields> & Partial<WebsiteStructureFields>
  video: VideoFields
  fullBrandBuild: BrandDesignFields
  logoDesign: LogoDesignFields
}
export interface TaskTypeOptions {
  socialAds: SocialAdFields
  displayAds: DisplayAdsFields
  updates: UpdateFields
  // conversionTracking: ConversionTrackingFields
  reviewAudit: ReviewFields
  budget: BudgetFields
  createSetup: CreationFields
  newClientOnboard: NewClientOnboardFields
  campaignChecklists: CampaignChecklistsFields
  adApprovals: AdApprovalsFields
  pause: PauseFields
  enable: EnableFields
}

export enum FieldType {
  TEXT = 'text',
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  MULTISELECT = 'multiselect',
  COLOR_PICKER = 'color_picker',
  NUMBER = 'number',
  TEXTAREA = 'textarea',
  DATE = 'date',
  AUTOCOMPLETE = 'autocomplete',
}
export interface FieldConfig {
  label: string
  type: FieldType
  board?: string
  options?: string[] // Used for select/multiselect fields
  placeholder?: string
  helperText?: string
  required?: boolean
  createdTime?: string
  assignee?: string // or UserDetail if you prefer full object
  startDate?: string
  endDate?: string
}
export const FormConfig: Record<keyof CreativeTypeOptions, Record<string, FieldConfig>> = {
  socialAds: {
    social_accessToCreative: {
      label: 'Access to Creative',
      type: FieldType.MULTISELECT,
      options: ['Brand Guide', 'Photography', 'Website Assets'],
      placeholder: 'What type of creative assets do we have access to?',
    },
    socialAdTypes: {
      label: 'Social Ad Types',
      type: FieldType.MULTISELECT,
      options: ['Static (1:1 and 9:16)', 'Static Carousel {Set of 3)', 'Video (1:1 and 9:16'],
    },

    sameOrNewTemplate: {
      label: 'Same or New Template (if applicable)?',
      type: FieldType.SELECT,
      options: ['Same', 'New'],
    },
    prevRequestLink: { label: 'Previous Request Link', type: FieldType.TEXT },
    reasonForRequestChange: { label: 'Reason for Request Change', type: FieldType.TEXTAREA },
    promotingDetails: { label: 'Promoting Details', type: FieldType.TEXTAREA, placeholder: 'What are we promoting?' },
    clientToExclude: {
      label: 'Client to Exclude',
      type: FieldType.TEXT,
      placeholder: 'Has the client specified anything they do not want in the creative?',
    },
    callToAction: { label: 'Call to Action', type: FieldType.TEXTAREA },
    vibe: {
      label: 'Vibe',
      type: FieldType.MULTISELECT,
      options: ['Youthful/Fun', 'Upscale', 'Edgy', 'Minimalistic', 'Modern'],
    },
  },
  displayAds: {
    display_accessToCreative: {
      label: 'Access to Creative',
      type: FieldType.MULTISELECT,
      options: ['Brand Guide', 'Photography', 'Website Assets'],
    },
    displayAdTypes: {
      label: 'Display Ad Types',
      type: FieldType.MULTISELECT,
      options: [
        'Standard Ad Set (160x600, 300x250, 300x600, 300x50, 728x90, 320x50)',
        'Responsive Ad Set (1200x628, 1200x1200)',
      ],
    },
    sameOrNewTemplate: { label: 'Same or New Template?', type: FieldType.SELECT, options: ['Same', 'New'] },
    prevRequestLink: { label: 'Previous Request Link', type: FieldType.TEXT },
    reasonForRequestChange: {
      label: 'Reason for Request Change',
      type: FieldType.TEXTAREA,
      placeholder:
        'Please be specific about the reason for the ad change. Is the leasing season changing? Is it for a new special? Did the client provide new photography? Please provide any and all details you can about this request.',
      required: true,
    },
    promotingDetails: { label: 'Promoting Details', type: FieldType.TEXTAREA, placeholder: 'What are we promoting?' },
    clientToExclude: {
      label: 'Client to Exclude',
      type: FieldType.TEXT,
      placeholder: 'Has the client specified anything they do not want in the creative?',
    },
    callToAction: { label: 'Call to Action', type: FieldType.TEXT },
    vibe: {
      label: 'Vibe',
      type: FieldType.MULTISELECT,
      options: ['Youthful/Fun', 'Upscale', 'Edgy', 'Minimalistic', 'Modern'],
    },
  },
  organicSocial: {
    promotingDetails: {
      label: 'Promoting Details',
      type: FieldType.TEXTAREA,
      placeholder:
        'Are we promoting anything specific? Do they have a new clubhouse? Did rates change? Is availability now limited?',
    },
    callToAction: {
      label: 'Call to Action',
      type: FieldType.TEXTAREA,
      placeholder: 'Should be different from their previous ad set.',
    },
    vibe: {
      label: 'Vibe',
      type: FieldType.MULTISELECT,
      options: ['Youthful/Fun', 'Upscale', 'Edgy', 'Minimalistic', 'Modern'],
    },
  },
  photography: {
    photographyType: {
      label: 'Photography Type',
      type: FieldType.SELECT,
      options: ['Lifestyle', 'Commercial', 'Drone', 'Headshots', 'Other'],
    },
    locations_photography: { label: 'Locations for Photography', type: FieldType.TEXT },
    photoUsage: { label: 'Photo Usage', type: FieldType.SELECT, options: ['Print', 'Web', 'Both'] },
  },
  printDesign: {
    printProjectType: {
      label: 'Print Project Type',
      type: FieldType.SELECT,
      options: ['Brochure', 'Billboard', 'Merchandise', 'Magazine Ad', 'Other'],
    },
    print_dimensions: { label: 'Print Dimensions', type: FieldType.TEXT },
    print_pages: { label: 'Number of Pages', type: FieldType.NUMBER },
    print_creative_asset_link: { label: 'Creative Asset Link', type: FieldType.TEXT },
    stockImages: { label: 'Stock Images', type: FieldType.SELECT, options: ['Yes', 'No', 'Designer’s Choice'] },
    print_phone: { label: 'Phone', type: FieldType.TEXT },
    print_address: { label: 'Address', type: FieldType.TEXT },
    print_website: { label: 'Website', type: FieldType.TEXT },
  },
  website: {
    websiteType: {
      label: 'Website Type',
      type: FieldType.SELECT,
      board: 'website',
      options: ['Full Website', 'Landing Page', 'Shopify', 'Other'],
    },
    website_existing_domain: { label: 'Domain (Existing Website)', type: FieldType.TEXT, board: 'website' },
    website_new_domain_input: { label: 'Domain (New Website)', type: FieldType.TEXT, board: 'website' },
    website_new_domain: {
      label: 'Access (New Website Domain)',
      type: FieldType.SELECT,
      board: 'website',
      options: ['Have Access', 'Need Access', 'Need to Purchase', 'Not Sure'],
    },
    website_domain_access: {
      label: 'Access (Existing Website)',
      type: FieldType.SELECT,
      board: 'website',
      options: ['Have Access', 'Need Access', 'Need to Purchase'],
    },
    google_analytics_access: {
      label: 'Access (Google Analytics)',
      type: FieldType.SELECT,
      board: 'website',
      options: ['Have Access', 'Need Access', 'Need to Create'],
    },
    website_content: {
      label: 'Content',
      type: FieldType.SELECT,
      board: 'website',
      options: ['Migrate Content', 'Create new content', 'Migrate & Create'],
    },
    use_stock_images: {
      label: 'Use Stock Images?',
      type: FieldType.SELECT,
      board: 'website',
      options: ['Yes', 'No', 'Defer to creative team'],
    },
    google_map_site: {
      label: 'Need Google map (on site)',
      type: FieldType.SELECT,
      board: 'website',
      options: ['Yes', 'No', 'Defer to creative team'],
    },
    need_contact_form: {
      label: 'Need Contact Form?',
      type: FieldType.SELECT,
      board: 'website',
      options: ['Yes', 'No', 'Defer to creative team'],
    },
    website_brand_style: {
      label: 'Brand Style',
      type: FieldType.MULTISELECT,
      options: [
        'Minimal & Modern',
        'Bold & Geometric',
        'Classic & Elegant',
        'Handwritten/Script',
        'Illustrative & Detailed',
      ],
    },
    website_creative_asset_link: { label: 'Creative Assets Link', type: FieldType.TEXT, board: 'website' },
    badge_compliance_images: { label: 'Badges / Compliance Images Needed', type: FieldType.TEXT },
    // inspiration_links: { label: 'Inspiration Links', type: FieldType.TEXT },
    website_pages: { label: '# of Pages', type: FieldType.NUMBER },
    // main_nav_links: { label: 'Main Nav Links', type: FieldType.TEXTAREA, board: 'website' },
    main_nav_cta: { label: 'Main Nav CTA', type: FieldType.TEXTAREA, board: 'website' },
    // footer_nav_links: { label: 'Footer Nav Links', type: FieldType.TEXTAREA, board: 'website' },
    website_links_info: {
      label: 'Links Info',
      type: FieldType.TEXTAREA,
      board: 'website',
      placeholder: 'Inspiration Links | Main Nav Links | Footer Nav Links',
    },
    website_addtl_info: { label: 'Addtl Info', type: FieldType.TEXTAREA, board: 'website' },
  },
  // websiteDesignOverview: {
  //   use_stock_images: {
  //     label: 'Use Stock Images?',
  //     type: FieldType.SELECT,
  //     board: 'website',
  //     options: ['Yes', 'No', 'Defer to creative team'],
  //   },
  //   google_map_site: {
  //     label: 'Need Google map (on site)',
  //     type: FieldType.SELECT,
  //     board: 'website',
  //     options: ['Yes', 'No', 'Defer to creative team'],
  //   },
  //   need_contact_form: {
  //     label: 'Need Contact Form?',
  //     type: FieldType.SELECT,
  //     board: 'website',
  //     options: ['Yes', 'No', 'Defer to creative team'],
  //   },
  //   website_brand_style: {
  //     label: 'Brand Style',
  //     type: FieldType.MULTISELECT,
  //     options: [
  //       'Minimal & Modern',
  //       'Bold & Geometric',
  //       'Classic & Elegant',
  //       'Handwritten/Script',
  //       'Illustrative & Detailed',
  //     ],
  //   },
  //   website_creative_asset_link: { label: 'Creative Assets Link', type: FieldType.TEXT, board: 'website' },
  //   badge_compliance_images: { label: 'Badges / Compliance Images Needed', type: FieldType.TEXT },
  //   inspiration_links: { label: 'Inspiration Links', type: FieldType.TEXT },
  // },
  // websiteStructure: {
  //   website_pages: { label: '# of Pages', type: FieldType.NUMBER },
  //   main_nav_links: { label: 'Main Nav Links', type: FieldType.TEXTAREA, board: 'website' },
  //   main_nav_cta: { label: 'Main Nav CTA', type: FieldType.TEXTAREA, board: 'website' },
  //   footer_nav_links: { label: 'Footer Nav Links', type: FieldType.TEXTAREA, board: 'website' },
  //   website_addtl_info: { label: 'Addtl Info', type: FieldType.TEXTAREA, board: 'website' },
  // },
  video: {
    videoType: {
      label: 'Type of Video',
      type: FieldType.SELECT,
      options: ['Lifestyle', 'Interview', 'Advertisement', 'Hype Video', 'Drone'],
    },
    goal_of_video: { label: 'Goal of Video', type: FieldType.TEXT },
    video_target_audience: { label: 'Target Audience', type: FieldType.TEXT },
    video_projected_hours: { label: 'Projected Hours', type: FieldType.NUMBER },
    video_locations: { label: 'Video Locations', type: FieldType.TEXTAREA },
    req_text_logo: { label: 'Required Text or Logos', type: FieldType.TEXT },
    specific_shots: { label: 'Specific Shots Requested', type: FieldType.TEXTAREA },
    output_channels: {
      label: 'Output Channels',
      type: FieldType.MULTISELECT,
      options: ['Social Ads', 'Website', 'Streaming', 'YouTube'],
    },
  },
  fullBrandBuild: {
    deliverables: {
      label: 'Contract Deliverables',
      type: FieldType.CHECKBOX,
      options: ['Logo', 'Visual ID', 'Brand Guide', 'Collateral'],
    },
    target_audience: { label: 'Target Audience', type: FieldType.TEXT },
    use_colors: { label: 'Colors to Use', type: FieldType.TEXT },
    avoid_colors: { label: 'Colors to Avoid', type: FieldType.TEXT },
    logo_inspiration: { label: 'Logo Inspiration', type: FieldType.TEXT },
    brand_style: {
      label: 'Brand Style',
      type: FieldType.MULTISELECT,
      options: [
        'Minimal & Modern',
        'Bold & Geometric',
        'Classic & Elegant',
        'Handwritten/Script',
        'Illustrative & Detailed',
      ],
    },
    primary_color: { label: 'Primary Color', type: FieldType.COLOR_PICKER },
    secondary_color: { label: 'Secondary Color', type: FieldType.COLOR_PICKER },
    accent_color: { label: 'Accent Color', type: FieldType.COLOR_PICKER },
  },
  logoDesign: {
    deliverables: {
      label: 'Contract Deliverables',
      type: FieldType.CHECKBOX,
      options: ['Logo', 'Visual ID', 'Brand Guide'],
    },
    target_audience: { label: 'Target Audience', type: FieldType.TEXT },
    use_colors: { label: 'Colors to Use', type: FieldType.TEXT },
    avoid_colors: { label: 'Colors to Avoid', type: FieldType.TEXT },
    logo_inspiration: { label: 'Logo Inspiration', type: FieldType.TEXT },

    logo_brand_style: {
      label: 'Brand Guide',
      type: FieldType.MULTISELECT,
      options: [
        'Minimal & Modern',
        'Bold & Geometric',
        'Classic & Elegant',
        'Handwritten/Script',
        'Illustrative & Detailed',
      ],
    },
    primary_color: { label: 'Primary Color', type: FieldType.COLOR_PICKER },
    secondary_color: { label: 'Secondary Color', type: FieldType.COLOR_PICKER },
    accent_color: { label: 'Accent Color', type: FieldType.COLOR_PICKER },
  },
}
export const creativeTaskTypeLabels: Record<keyof CreativeTypeOptions, string> = {
  socialAds: 'Social Ads',
  displayAds: 'Display Ads',
  organicSocial: 'Organic Social',
  photography: 'Photography',
  printDesign: 'Print Design',
  website: 'Website',
  video: 'Video',
  fullBrandBuild: 'Full Brand Build',
  logoDesign: 'Logo Design',
}

const creativeTypeOptions = [
  'Social Ads',
  'Display Ads',
  'Organic Social',
  'Photography',
  'Print Design',
  'Website',
  'Website Design Overview',
  'Website Structure',
  'Video',
  'Full Brand Build',
  'Logo Design',
]

// Ad Options
export const socialAdOptions = ['Static (1:1 and 9:16)', 'Static Carousel (Set of 3)', 'Video (1:1 and 9:16)']
export const displayAdOptions = [
  'Standard Ad Set (160x600, 300x250, 300x600, 300x50, 728x90, 320x50)',
  'Responsive Ad Set (1200x628, 1200x1200)',
]
export const existingClientOptions = [
  { key: 'existingClient-true', label: 'True', value: true },
  { key: 'existingClient-false', label: 'False', value: false },
]

export const initialFormData: CreativeFormData = {
  name: '',
  orgId: '',
  website: '',
  assigner: {
    id: '',
    user_uuid: '',
    first_name: '',
    last_name: '',
    firstName: '',
    lastName: '',
    name: '',
  } as User,
  assignees: [],
  AM: [],
  DMS: [],
  creativeLead: [],
  priority: '',
  startDate: '',
  endDate: '',
  deadline: '',
  existingClient: false,
  types: [],
  requestType: '',
  requestedBy: '',
  taskType: '',
  createdTime: '',
  addtlNotes: '',
  type: '',
  creativeType: '',
  creativeStatus: '',
  channel: '',
  creativeTasksFolderId: '',
  tasksFolderId: '',
}
export const initialMarketingFormData: MarketingFormData = {
  name: '',
  orgId: '',
  website: '',
  assigner: {
    id: '',
    user_uuid: '',
    first_name: '',
    last_name: '',
    firstName: '',
    lastName: '',
    name: '',
  } as User,
  assignees: [],
  creativeTasksFolderId: '',
  googleDriveFolderId: '',
  tasksFolderId: '',
  channel: [],
  channels: [],
  AM: [],
  DMS: [],
  priority: '',
  startDate: '',
  endDate: '',
  deadline: '',
  existingClient: false,
  taskType: '',
  requestType: '',
  requestedBy: '',
  typeDesignation: '',
  typeDesignationSpecifics: '',
  searchPlatform: '',
  socialPlatform: '',
  displayPlatform: '',
  createdTime: '',
  addtlNotes: '',
  type: '',
}

export interface CreativeIntakeProps {
  open: boolean
  onClose: () => void
  prefillData?: Partial<CreativeFormData>
}
export interface MarketingFormProps {
  open: boolean
  onClose: (...args: any[]) => void
}

// Initialize fields for each request type
const getInitialFields = <T>(defaultValues: T): T => ({ ...defaultValues })

export const initialRequestFields: CreativeTypeOptions = {
  socialAds: getInitialFields<SocialAdFields>({
    dmsAssignment: '',
    social_accessToCreative: '',
    socialAdTypes: [],
    sameOrNewTemplate: '',
    prevRequestLink: '',
    reasonForRequestChange: '',
    promotingDetails: '',
    clientToExclude: '',
    callToAction: '',
    vibe: '',
  }),
  displayAds: getInitialFields<DisplayAdsFields>({
    dmsAssignment: '',
    display_accessToCreative: '',
    displayAdTypes: [],
    sameOrNewTemplate: '',
    prevRequestLink: '',
    reasonForRequestChange: '',
    promotingDetails: '',
    clientToExclude: '',
    callToAction: '',
    vibe: '',
  }),
  organicSocial: getInitialFields<OrganicSocialFields>({
    promotingDetails: '',
    callToAction: '',
    vibe: '',
  }),
  photography: getInitialFields<PhotographyFields>({
    photographyType: '',
    locations_photography: '',
    photoUsage: '',
  }),
  printDesign: getInitialFields<PrintDesignFields>({
    printProjectType: '',
    print_dimensions: '',
    print_pages: '',
    print_creative_asset_link: '',
    stockImages: '',
    print_phone: '',
    print_address: '',
    print_website: '',
  }),
  website: getInitialFields<WebsiteFields & Partial<WebsiteDesignFields> & Partial<WebsiteStructureFields>>({
    websiteType: '',
    website_existing_domain: '',
    website_new_domain_input: '',
    google_analytics_access: '',
    website_new_domain: '',
    website_domain_access: '',
    // website_ssl_cert: '',
    website_google_analytics: '',
    website_content: '',
    website_street: '',
    website_phone: '',
    website_city: '',
    website_state: '',
    website_bus_email: '',
    website_brand_style: '',
    website_creative_asset_link: '',
    use_stock_images: '',
    google_map_site: '',
    need_contact_form: '',
    badge_compliance_images: '',
    inspiration_links: '',
    hero_image_headline: '',
    hero_image_cta: '',
    website_pages: 0,
    main_nav_links: '',
    main_nav_cta: '',
    footer_nav_links: '',
    website_addtl_info: '',
  }),
  video: getInitialFields<VideoFields>({
    videoType: '',
    goal_of_video: '',
    video_target_audience: '',
    video_projected_hours: 0,
    video_locations: '',
    video_personell: '',
    req_text_logo: '',
    specific_shots: '',
    output_channels: '',
    video_sizes: '',
    video_min_duration: '',
    video_max_duration: '',
  }),
  fullBrandBuild: getInitialFields<BrandDesignFields>({
    brand_deliverables: '',
    brand_target_audience: '',
    brand_use_colors: '',
    brand_avoid_colors: '',
    brand_style: '',
    brand_logo_inspiration: '',
    brand_color_picker1: '',
    brand_color_picker2: '',
    brand_color_picker3: '',
  }),
  logoDesign: getInitialFields<LogoDesignFields>({
    logo_deliverables: '',
    logo_target_audience: '',
    logo_use_colors: '',
    logo_avoid_colors: '',
    logo_brand_style: '',
    logo_inspiration: '',
    logo_color_picker1: '',
    logo_color_picker2: '',
    logo_color_picker3: '',
  }),
}
////////////////// Marketing field type definitions and mappings /////////////////////////
// export interface ConversionTrackingFields {
//   defaultField1: string
//   defaultField2: string
// }
export interface CampaignUpdateFields {
  defaultField1: string
  defaultField2: string
}
export interface UpdateFields {
  channel: string[]
  platform: string[]
}
export interface BudgetFields {
  channel: string[]
  platform: string[]
}
export interface CreationFields {
  channel: string[]
  platform: string[]
}
export interface NewClientOnboardFields {
  channel: string[]
  platform: string[]
}
export interface ReviewFields {
  channel: string[]
  platform: string[]
}
export interface SeoFields {
  channel: string[]
  platform: string[]
}
export interface CampaignChecklistsFields {
  channel: string[]
  platform: string[]
}
export interface AdApprovalsFields {
  channel: string[]
  platform: string[]
}
export interface PauseFields {
  channel: string[]
  platform: string[]
}
export interface EnableFields {
  channel: string[]
  platform: string[]
}
export const MarketingFormConfig: Record<keyof TaskTypeOptions, Record<string, FieldConfig>> = {
  socialAds: {
    social_accessToCreative: {
      label: 'Access to Creative',
      type: FieldType.MULTISELECT,
      options: ['Brand Guide', 'Photography', 'Website Assets'],
      placeholder: 'What type of creative assets do we have access to?',
    },
    socialAdTypes: {
      label: 'Social Ad Types',
      type: FieldType.MULTISELECT,
      options: ['Static (1:1 and 9:16)', 'Static Carousel {Set of 3)', 'Video (1:1 and 9:16'],
    },

    sameOrNewTemplate: {
      label: 'Same or New Template (if applicable)?',
      type: FieldType.SELECT,
      options: ['Same', 'New'],
    },
    prevRequestLink: { label: 'Previous Request Link', type: FieldType.TEXT },
    reasonForRequestChange: { label: 'Reason for Request Change', type: FieldType.TEXTAREA },
    promotingDetails: { label: 'Promoting Details', type: FieldType.TEXTAREA, placeholder: 'What are we promoting?' },
    clientToExclude: {
      label: 'Client to Exclude',
      type: FieldType.TEXT,
      placeholder: 'Has the client specified anything they do not want in the creative?',
    },
    callToAction: { label: 'Call to Action', type: FieldType.TEXTAREA },
    vibe: {
      label: 'Vibe',
      type: FieldType.MULTISELECT,
      options: ['Youthful/Fun', 'Upscale', 'Edgy', 'Minimalistic', 'Modern'],
    },
  },
  displayAds: {
    display_accessToCreative: {
      label: 'Access to Creative',
      type: FieldType.MULTISELECT,
      options: ['Brand Guide', 'Photography', 'Website Assets'],
    },
    displayAdTypes: {
      label: 'Display Ad Types',
      type: FieldType.MULTISELECT,
      options: [
        'Standard Ad Set (160x600, 300x250, 300x600, 300x50, 728x90, 320x50)',
        'Responsive Ad Set (1200x628, 1200x1200)',
      ],
    },
    sameOrNewTemplate: { label: 'Same or New Template?', type: FieldType.SELECT, options: ['Same', 'New'] },
    prevRequestLink: { label: 'Previous Request Link', type: FieldType.TEXT },
    reasonForRequestChange: {
      label: 'Reason for Request Change',
      type: FieldType.TEXTAREA,
      placeholder:
        'Please be specific about the reason for the ad change. Is the leasing season changing? Is it for a new special? Did the client provide new photography? Please provide any and all details you can about this request.',
      required: true,
    },
    promotingDetails: { label: 'Promoting Details', type: FieldType.TEXTAREA, placeholder: 'What are we promoting?' },
    clientToExclude: {
      label: 'Client to Exclude',
      type: FieldType.TEXT,
      placeholder: 'Has the client specified anything they do not want in the creative?',
    },
    callToAction: { label: 'Call to Action', type: FieldType.TEXT },
    vibe: {
      label: 'Vibe',
      type: FieldType.MULTISELECT,
      options: ['Youthful/Fun', 'Upscale', 'Edgy', 'Minimalistic', 'Modern'],
    },
  },
  budget: {
    channel: {
      label: 'Channel',
      type: FieldType.MULTISELECT,
      options: ['Search', 'Social', 'Display', 'Video', 'SEO'],
      required: true,
    },
  },
  createSetup: {
    channel: {
      label: 'Channel',
      type: FieldType.MULTISELECT,
      options: ['Search', 'Social', 'Display', 'Video', 'SEO', 'Integration'],
      required: true,
    },
  },
  updates: {
    channel: {
      label: 'Channel',
      type: FieldType.MULTISELECT,
      options: ['Search', 'Social', 'Display', 'Video', 'SEO', 'Integration'],
      required: true,
    },
  },
  newClientOnboard: {
    channel: {
      label: 'Channel',
      type: FieldType.MULTISELECT,
      options: ['Search', 'Social', 'Display', 'Video', 'SEO', 'Integration'],
      required: true,
    },
  },
  reviewAudit: {
    channel: {
      label: 'Channel',
      type: FieldType.MULTISELECT,
      options: ['Search', 'Social', 'Display', 'Video', 'SEO', 'Integration'],
      required: true,
    },
  },
  campaignChecklists: {
    channel: {
      label: 'Channel',
      type: FieldType.MULTISELECT,
      options: ['Search', 'Social', 'Display', 'Video'],
      required: true,
    },
  },
  adApprovals: {
    channel: {
      label: 'Channel',
      type: FieldType.MULTISELECT,
      options: ['Search', 'Social', 'Display', 'Video'],
      required: true,
    },
  },
  pause: {
    channel: {
      label: 'Channel',
      type: FieldType.MULTISELECT,
      options: ['Search', 'Social', 'Display', 'Video', 'SEO', 'Integration'],
      required: true,
    },
  },
  enable: {
    channel: {
      label: 'Channel',
      type: FieldType.MULTISELECT,
      options: ['Search', 'Social', 'Display', 'Video', 'SEO', 'Integration'],
      required: true,
    },
  },
}

export const taskTypeLabels: Record<string, string> = {
  socialAds: 'Social Ads',
  displayAds: 'Display Ads',
  updates: 'Updates',
  reviewAudit: 'Review / Audit',
  budget: 'Budget',
  createSetup: 'Create / Setup',
  newClientOnboard: 'New Client Onboard',
  campaignChecklists: 'Campaign Checklist',
  adApprovals: 'Ad Approval',
  pause: 'Pause',
  enable: 'Enable',
  creativeIntake: 'Creative Intake',
  concept: 'Concept',
  design: 'Design',
  proofs: 'Proofs',
  revisions: 'Revisions',
  assetHandoff: 'Asset Handoff',
  finalDelivery: 'Final Delivery',
}

export const reviewChannelFields: Record<string, Record<string, FieldConfig>> = {
  Search: {
    searchPlatform: {
      label: 'Search Platform',
      type: FieldType.MULTISELECT,
      options: ['Microsoft', 'Google'],
    },
    searchReview: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Performance', 'Ad Copy', 'Website', 'Keywords', 'Search Terms', 'Campaign Settings', 'Other'],
    },
  },
  Social: {
    socialPlatform: {
      label: 'Social Platform',
      type: FieldType.MULTISELECT,
      options: ['Meta', 'Instagram', 'Snapchat', 'LinkedIn', 'TikTok'],
    },
    socialReview: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: [
        'Performance',
        'Ad Copy',
        'Website',
        'Audience',
        'Targeting',
        'Campaign Settings',
        'Placements',
        'Other',
      ],
    },
  },
  Display: {
    displayPlatform: {
      label: 'Display Platform',
      type: FieldType.MULTISELECT,
      options: ['Google', 'Simplifi'],
    },
    displayReview: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Performance', 'Audience', 'Targeting', 'Campaign Settings', 'Placements', 'Other'],
    },
  },
  Video: {
    videoPlatform: {
      label: 'Video Platform',
      type: FieldType.MULTISELECT,
      options: ['YouTube', 'TikTok', 'Simplifi'],
    },
    videoReview: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Performance', 'Audience', 'Targeting', 'Campaign Settings', 'Placements', 'Other'],
    },
  },
  SEO: {
    seoReview: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: [
        'Website',
        'Keywords / Keyword Rankings',
        'Name/Address/Phone Number/Business Hours',
        'Google Business Profile',
      ],
    },
  },
  Integration: {
    integrationReview: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['GTM', 'GA4', 'Triggers / Tags', 'Events', 'Conversion Tracking'],
    },
  },
}
export const updateChannelFields: Record<string, Record<string, FieldConfig>> = {
  Search: {
    searchPlatform: {
      label: 'Search Platform',
      type: FieldType.MULTISELECT,
      options: ['Microsoft', 'Google'],
    },
    searchUpdate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: [
        'Performance',
        'Ad Copy',
        'Website',
        'Keywords',
        'Search Terms',
        'Campaign Settings',
        'Other',
        'Existing Domain',
        'Additional Domain',
      ],
    },
  },
  Social: {
    socialPlatform: {
      label: 'Social Platform',
      type: FieldType.MULTISELECT,
      options: ['Meta', 'Instagram', 'Snapchat', 'LinkedIn', 'TikTok'],
    },
    socialUpdate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: [
        'Performance',
        'Ad Copy',
        'Website',
        'Audience',
        'Targeting',
        'Campaign Settings',
        'Placements',
        'Boosted Post',
        'Other',
        'Existing Domain',
        'Additional Domain',
      ],
    },
  },
  Display: {
    displayPlatform: {
      label: 'Display Platform',
      type: FieldType.MULTISELECT,
      options: ['Google', 'Simplifi'],
    },
    displayUpdate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: [
        'Performance',
        'Audience',
        'Targeting',
        'Campaign Settings',
        'Placements',
        'Other',
        'Existing Domain',
        'Additional Domain',
      ],
    },
  },
  Video: {
    videoPlatform: {
      label: 'Video Platform',
      type: FieldType.MULTISELECT,
      options: ['YouTube', 'TikTok', 'Simplifi'],
    },
    videoUpdate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: [
        'Performance',
        'Audience',
        'Targeting',
        'Campaign Settings',
        'Placements',
        'Other',
        'Existing Domain',
        'Additional Domain',
      ],
    },
  },
  SEO: {
    seoUpdate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: [
        'Updates',
        'Website',
        'Existing Domain',
        'Additional Domain',
        'Keywords / Keyword Rankings',
        'Name/Address/Phone Number/Business Hours',
        'Google Business Profile',
        'Tier Upgrade',
        'Tier Downgrade',
        'On-Site',
        'Off-Site',
      ],
    },
  },
  Integration: {
    integrationUpdate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['GTM', 'GA4', 'Triggers / Tags', 'Events', 'Conversion Tracking'],
    },
  },
}
export const budgetChannelFields: Record<string, Record<string, FieldConfig>> = {
  Search: {
    searchPlatform: {
      label: 'Search Platform',
      type: FieldType.MULTISELECT,
      options: ['Microsoft', 'Google'],
    },
    searchBudget: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Budget Increase', 'Budget Decrease', 'Budget Recommendation', 'Budget Audit'],
    },
  },
  Social: {
    socialPlatform: {
      label: 'Social Platform',
      type: FieldType.MULTISELECT,
      options: ['Meta', 'Instagram', 'Snapchat', 'LinkedIn', 'TikTok'],
    },
    socialBudget: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Budget Increase', 'Budget Decrease', 'Budget Recommendation', 'Budget Audit'],
    },
  },
  Display: {
    displayPlatform: {
      label: 'Display Platform',
      type: FieldType.MULTISELECT,
      options: ['Google', 'Simplifi'],
    },
    displayBudget: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Budget Increase', 'Budget Decrease', 'Budget Recommendation', 'Budget Audit'],
    },
  },
  Video: {
    videoPlatform: {
      label: 'Video Platform',
      type: FieldType.MULTISELECT,
      options: ['YouTube', 'TikTok', 'Simplifi'],
    },
    videoBudget: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Budget Increase', 'Budget Decrease', 'Budget Recommendation', 'Budget Audit'],
    },
  },
  SEO: {
    seoBudget: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      // options: ['Vendasta', 'SE Ranking'],
      options: ['Recommendations', 'Increase', 'Decrease'],
    },
  },
}
export const createSetupChannelFields: Record<string, Record<string, FieldConfig>> = {
  Search: {
    searchPlatform: {
      label: 'Search Platform',
      type: FieldType.MULTISELECT,
      options: ['Microsoft', 'Google'],
    },
    searchCreate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Performance', 'Ad Copy', 'Website', 'Keywords', 'Search Terms', 'Campaign Settings', 'Other'],
    },
  },
  Social: {
    socialPlatform: {
      label: 'Social Platform',
      type: FieldType.MULTISELECT,
      options: ['Meta', 'Instagram', 'Snapchat', 'LinkedIn', 'TikTok'],
    },
    socialCreate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: [
        'Performance',
        'Ad Copy',
        'Website',
        'Audience',
        'Targeting',
        'Campaign Settings',
        'Placements',
        'Other',
      ],
    },
  },
  Display: {
    displayPlatform: {
      label: 'Display Platform',
      type: FieldType.MULTISELECT,
      options: ['Google', 'Simplifi'],
    },
    displayCreate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Performance', 'Audience', 'Targeting', 'Campaign Settings', 'Placements', 'Other'],
    },
  },
  Video: {
    videoPlatform: {
      label: 'Video Platform',
      type: FieldType.MULTISELECT,
      options: ['YouTube', 'TikTok', 'Simplifi'],
    },
    videoCreate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Performance', 'Audience', 'Targeting', 'Campaign Settings', 'Placements', 'Other'],
    },
  },
  SEO: {
    seoCreate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['GBP', 'Listing Citations (Vendasta)'],
    },
  },
  Integration: {
    integrationCreate: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['GTM', 'GA4', 'Triggers / Tags', 'Events', 'Conversion Tracking'],
    },
  },
}
export const newClientOnboardFields: Record<string, Record<string, FieldConfig>> = {
  Search: {
    searchPlatform: {
      label: 'Search Platform',
      type: FieldType.MULTISELECT,
      options: ['Microsoft', 'Google'],
    },
    searchNco: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['QA', 'Other'],
    },
  },
  Social: {
    socialPlatform: {
      label: 'Social Platform',
      type: FieldType.MULTISELECT,
      options: ['Meta', 'Instagram', 'Snapchat', 'LinkedIn', 'TikTok'],
    },
    socialNco: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['QA', 'Other'],
    },
  },
  Display: {
    displayPlatform: {
      label: 'Display Platform',
      type: FieldType.MULTISELECT,
      options: ['Google', 'Simplifi'],
    },
    displayNco: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['QA', 'Other'],
    },
  },
  Video: {
    videoPlatform: {
      label: 'Video Platform',
      type: FieldType.MULTISELECT,
      options: ['YouTube', 'TikTok', 'Simplifi'],
    },
    videoNco: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['QA', 'Other'],
    },
  },
  SEO: {
    seoNco: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Tier 1', 'Tier 2', 'Tier 3', 'Tier 4', 'Custom'],
    },
  },
  Integration: {
    integrationNco: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['GTM', 'GA4', 'Triggers / Tags', 'Events', 'Conversion Tracking', 'Meta', 'Linkedin'],
    },
  },
}
export const pauseFields: Record<string, Record<string, FieldConfig>> = {
  Search: {
    searchPlatform: {
      label: 'Search Platform',
      type: FieldType.MULTISELECT,
      options: ['Microsoft', 'Google'],
    },
    searchPause: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Campaign', 'Ads', 'Keywords', 'Ad Groups'],
    },
  },
  Social: {
    socialPlatform: {
      label: 'Social Platform',
      type: FieldType.MULTISELECT,
      options: ['Meta', 'Instagram', 'Snapchat', 'LinkedIn', 'TikTok'],
    },
    socialPause: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Campaign', 'Ads', 'Keywords', 'Ad Sets', 'Ad Groups'],
    },
  },
  Display: {
    displayPlatform: {
      label: 'Display Platform',
      type: FieldType.MULTISELECT,
      options: ['Google', 'Simplifi'],
    },
    displayPause: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Campaign', 'Ads', 'Campaign Group', 'Ad Group'],
    },
  },
  Video: {
    videoPlatform: {
      label: 'Video Platform',
      type: FieldType.MULTISELECT,
      options: ['YouTube', 'TikTok', 'Simplifi'],
    },
    videoPause: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Campaign', 'Ads', 'Campaign Group', 'Ad Group'],
    },
  },
  SEO: {
    seoPause: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['SEO Campaign'],
    },
  },
  // Integration: {
  //   integrationPause: {
  //     label: 'Options',
  //     type: FieldType.MULTISELECT,
  //     options: ['Campaign', 'Ads', 'Keywords', 'Ad Sets', 'Ad Groups'],
  //   },
  // },
}
export const enableFields: Record<string, Record<string, FieldConfig>> = {
  Search: {
    searchPlatform: {
      label: 'Search Platform',
      type: FieldType.MULTISELECT,
      options: ['Microsoft', 'Google'],
    },
    searchEnable: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Campaign', 'Ads', 'Keywords', 'Ad Groups'],
    },
  },
  Social: {
    socialPlatform: {
      label: 'Social Platform',
      type: FieldType.MULTISELECT,
      options: ['Meta', 'Instagram', 'Snapchat', 'LinkedIn', 'TikTok'],
    },
    socialEnable: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Campaign', 'Ads', 'Keywords', 'Ad Sets', 'Ad Groups'],
    },
  },
  Display: {
    displayPlatform: {
      label: 'Display Platform',
      type: FieldType.MULTISELECT,
      options: ['Google', 'Simplifi'],
    },
    displayEnable: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Campaign', 'Ads', 'Campaign Group', 'Ad Group'],
    },
  },
  Video: {
    videoPlatform: {
      label: 'Video Platform',
      type: FieldType.MULTISELECT,
      options: ['YouTube', 'TikTok', 'Simplifi'],
    },
    videoEnable: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Campaign', 'Ads', 'Campaign Group', 'Ad Group'],
    },
  },
  SEO: {
    seoEnable: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['SEO Campaign'],
    },
  },
  // Integration: {
  //   integrationEnable: {
  //     label: 'Options',
  //     type: FieldType.MULTISELECT,
  //     options: ['Campaign', 'Keywords', 'Ad Sets', 'Ad Groups'],
  //   },
  // },
}
export const campaignChecklistFields: Record<string, Record<string, FieldConfig>> = {
  Search: {
    searchCampaignPlatform: {
      label: 'Search Platform',
      type: FieldType.MULTISELECT,
      options: ['Microsoft', 'Google'],
    },
  },
  Social: {
    socialCampaignPlatform: {
      label: 'Social Platform',
      type: FieldType.MULTISELECT,
      options: ['Meta', 'Instagram', 'Snapchat', 'LinkedIn', 'TikTok'],
    },
  },
  Display: {
    displayCampaignPlatform: {
      label: 'Display Platform',
      type: FieldType.MULTISELECT,
      options: ['Google', 'Simplifi'],
    },
  },
  Video: {
    videoCampaignPlatform: {
      label: 'Video Platform',
      type: FieldType.MULTISELECT,
      options: ['YouTube', 'TikTok', 'Simplifi'],
    },
  },
  SEO: {
    seoCampaignChecklist: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Campaign', 'Ads', 'Keywords', 'Ad Sets', 'Ad Groups'],
    },
  },
  Integration: {
    integrationCampaignChecklist: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Campaign', 'Keywords', 'Ad Sets', 'Ad Groups'],
    },
  },
}
export const adApprovalsFields: Record<string, Record<string, FieldConfig>> = {
  Search: {
    searchAdPlatform: {
      label: 'Search Platform',
      type: FieldType.MULTISELECT,
      options: ['Microsoft', 'Google'],
    },
  },
  Social: {
    socialAdPlatform: {
      label: 'Social Platform',
      type: FieldType.MULTISELECT,
      options: ['Meta', 'Instagram', 'Snapchat', 'LinkedIn', 'TikTok'],
    },
  },
  Display: {
    displayAdPlatform: {
      label: 'Display Platform',
      type: FieldType.MULTISELECT,
      options: ['Google', 'Simplifi'],
    },
  },
  Video: {
    videoAdPlatform: {
      label: 'Video Platform',
      type: FieldType.MULTISELECT,
      options: ['YouTube', 'TikTok', 'Simplifi'],
    },
  },
}
// Is there a rebrand? // Most likely needs to be RMSA
export const newDomainFields: Record<string, Record<string, FieldConfig>> = {
  Search: {
    searchPlatform: {
      label: 'Search Platform',
      type: FieldType.MULTISELECT,
      options: ['Microsoft', 'Google'],
    },
    searchBudget: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Budget Increase', 'Budget Decrease', 'Budget Recommendation', 'Budget Audit'],
    },
  },
  Social: {
    socialPlatform: {
      label: 'Social Platform',
      type: FieldType.MULTISELECT,
      options: ['Meta', 'Instagram', 'Snapchat', 'LinkedIn', 'TikTok'],
    },
    socialBudget: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Budget Increase', 'Budget Decrease', 'Budget Recommendation', 'Budget Audit'],
    },
  },
  Display: {
    displayPlatform: {
      label: 'Display Platform',
      type: FieldType.MULTISELECT,
      options: ['Google', 'Simplifi'],
    },
    displayBudget: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Budget Increase', 'Budget Decrease', 'Budget Recommendation', 'Budget Audit'],
    },
  },
  Video: {
    videoPlatform: {
      label: 'Video Platform',
      type: FieldType.MULTISELECT,
      options: ['YouTube', 'TikTok', 'Simplifi'],
    },
    videoBudget: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      options: ['Budget Increase', 'Budget Decrease', 'Budget Recommendation', 'Budget Audit'],
    },
  },
  SEO: {
    seoBudget: {
      label: 'Options',
      type: FieldType.MULTISELECT,
      // options: ['Vendasta', 'SE Ranking'],
      options: ['Recommendations', 'Increase', 'Decrease'],
    },
  },
}
export const channelFieldMap: Record<string, Record<string, Record<string, FieldConfig>>> = {
  reviewAudit: reviewChannelFields,
  updates: updateChannelFields,
  budget: budgetChannelFields,
  createSetup: createSetupChannelFields,
  newClientOnboard: newClientOnboardFields,
  campaignChecklists: campaignChecklistFields,
  adApprovals: adApprovalsFields,
  pause: pauseFields,
  enable: enableFields,
}

export interface SubtaskRelevantData {
  type: string
  channel?: string[] | string
  searchPlatform?: string[] | string
  socialPlatform?: string[] | string
  displayPlatform?: string[] | string
  // Add others only if your subtask generator reads them
}

export const generateDynamicSubtasks = (
  type: string,
  formData: SubtaskRelevantData
): Record<
  string,
  {
    label: string
    channel: string
    option: string
    platform?: string
  }
> => {
  const subtasks: Record<string, { label: string; channel: string; option: string; platform?: string }> = {}

  const channelMap = channelFieldMap[type]
  if (!channelMap) return subtasks

  const selectedChannels = Array.isArray(formData.channel)
    ? formData.channel
    : formData.channel
    ? [formData.channel]
    : []

  selectedChannels.forEach(channel => {
    const fields = channelMap[channel]
    if (!fields) return

    // Find the platform field key, e.g. "socialPlatform", "searchPlatform"
    const platformFieldKey = Object.keys(fields).find(key => key.toLowerCase().includes('platform'))
    const selectedPlatforms = formData[platformFieldKey as keyof MarketingFormData]

    // Find the options field key
    const optionFieldKey = Object.keys(fields).find(
      key =>
        key.toLowerCase().includes('review') ||
        key.toLowerCase().includes('update') ||
        key.toLowerCase().includes('budget') ||
        key.toLowerCase().includes('create') ||
        key.toLowerCase().includes('pause') ||
        key.toLowerCase().includes('enable') ||
        key.toLowerCase().includes('nco') ||
        key.toLowerCase().includes('checklist')
    )

    const selectedOptions = formData[optionFieldKey as keyof MarketingFormData] || []
    if (Array.isArray(selectedOptions)) {
      selectedOptions
        .filter(option => !!option?.trim()) // Only include truthy, non-empty options
        .forEach(option => {
          const key = `${channel}_${option.replace(/\s+/g, '_')}`

          subtasks[key] = {
            label: option,
            channel,
            option,
            platform: Array.isArray(selectedPlatforms)
              ? selectedPlatforms.join(' | ')
              : typeof selectedPlatforms === 'string'
              ? selectedPlatforms
              : undefined,
          }
        })
    }
  })

  return subtasks
}
export const extractSubtaskRelevantData = (data: MarketingFormData): SubtaskRelevantData => {
  const { type, channel, searchPlatform, socialPlatform, displayPlatform } = data
  return { type, channel, searchPlatform, socialPlatform, displayPlatform }
}
export const validateField = (
  type: keyof typeof MarketingFormConfig,
  name: string,
  value: any
): { value: boolean; errorText: string } | null => {
  const fieldConfig = MarketingFormConfig[type]?.[name]
  const isRequired = fieldConfig?.required ?? false
  const isEmpty = value === '' || value === null || (Array.isArray(value) && value.length === 0)

  if (isRequired && isEmpty) {
    return {
      value: true,
      errorText: `${fieldConfig?.label || name} is required`,
    }
  }

  return null
}
